import React, { useState } from "react";
import Loading from "../Loading";
import RaceInfo from "../container/RaceInfo";
import WagerTypesRace from "../container/WagerTypesRace";
import Swal from "sweetalert2";
import EntriesTable from "../../wagerTypes/EntriesTable";
import Results from "../../wagerTypes/Results";
import Betslip from "../betslip/Betslip";
import WagerTypes from "../../constants/WagerTypes";

const Container = ({
  trackInfo,
  raceID,
  entriesInfo,
  loginPlayerInfo,
  resultsList,
  getEntriesRace,
  entriesPicks,
  getStatistics,
  session,
  setSessionNoLongerExists,
  getWagerGUID,
  publicIP,
}) => {
  const [loading, setLoading] = useState(false);
  const [cart, setCart] = useState([]);
  const [ticketIndex, setTicketIndex] = useState(1);
  const [indexTab, setIndexTab] = useState(1);
  const [checkBoxState, setCheckBoxState] = useState(true);
  const [amounts, setAmounts] = useState({});

  //Función para realizar el set de la apuesta
  const addToCart = async (event, horiz, currentTicketIndex) => {
    const wagerType = parseInt(event.getAttribute("idwt"));
    let IDTicket = ticketIndex + currentTicketIndex + 1;

    const existingTicket = cart.find(
      (ticket) =>
        ticket.wagerType === wagerType &&
        ticket.indexTab === indexTab &&
        ticket.raceID === parseInt(event.getAttribute("raceid")) &&
        ticket.entryNum === parseInt(event.getAttribute("entrynum"))
    );

    let CustomID = existingTicket
      ? existingTicket.wagerGUID
      : await getWagerGUID();

    if (event.checked) {
      if (
        wagerType === WagerTypes.WIN.id ||
        wagerType === WagerTypes.PLACE.id ||
        wagerType === WagerTypes.SHOW.id
      ) {
        if (horiz) {
          IDTicket = ticketIndex + 1;
          setTicketIndex((ticketIndex) => ticketIndex + 1);
          CustomID = await getWagerGUID();
        } else {
          IDTicket = ticketIndex + currentTicketIndex + 1;
          setTicketIndex((ticketIndex) => ticketIndex + currentTicketIndex);
          CustomID = await getWagerGUID();
        }
      }

      // Crear ticket
      let ticket = {
        wagerType: wagerType,
        saddleNum: event.getAttribute("saddlenum"),
        entryNum: parseInt(event.getAttribute("entrynum")),
        entryName: event.getAttribute("entryname"),
        position: parseInt(event.getAttribute("position")),
        raceID: parseInt(event.getAttribute("raceid")),
        custID: IDTicket, // único, pero no afecta el orden
        racenumber: event.getAttribute("racenum") || "",
        wagerGUID: CustomID,
        indexTab: indexTab,
      };

      const isDuplicate =
        wagerType === WagerTypes.WIN.id ||
        wagerType === WagerTypes.PLACE.id ||
        wagerType === WagerTypes.SHOW.id
          ? cart.some(
              (bet) =>
                bet.wagerType === ticket.wagerType &&
                bet.raceID === ticket.raceID &&
                bet.entryNum === ticket.entryNum &&
                bet.indexTab === ticket.indexTab
            )
          : cart.some(
              (bet) =>
                bet.saddleNum === ticket.saddleNum &&
                bet.wagerType === ticket.wagerType &&
                bet.position === ticket.position &&
                bet.raceID === ticket.raceID &&
                bet.indexTab === ticket.indexTab
            );

      if (!isDuplicate) {
        setCart((cart) => [ticket, ...cart]);
      }
    } else {
      // Eliminar un ticket del cart
      const removeIndex = cart.findIndex(
        (item) =>
          item.saddleNum === event.getAttribute("saddlenum") &&
          item.wagerType === wagerType &&
          item.position === parseInt(event.getAttribute("position")) &&
          item.raceID === parseInt(event.getAttribute("raceid"))
      );

      if (removeIndex !== -1) {
        cart.splice(removeIndex, 1);
        setCart([...cart]);
      }
    }

    document.getElementById("betSlip-tab").classList.add("active");
    document.getElementById("openBets-tab").classList.remove("active");
    document.getElementById("openbets").classList.remove("active", "show");
    document.getElementById("betslip").classList.add("active", "show");
  };

  //Function clean all checkbox from the table (ClearAll)
  const uncheckedAll = () => {
    document
      .querySelectorAll("input[type=checkbox]")
      .forEach(function (checkElement) {
        checkElement.checked = false;
        checkElement.disabled = false;
        if (checkElement.name === "chkBox") {
          checkElement.disabled = true;
        }
      });
  };

  //Function clean all checkbox and disable them from the table when checking the box
  const disabledAll = (event) => {
    // create new ticket
    setTicketIndex(ticketIndex + 1);
    // document.querySelectorAll   GET ALL CHECKBOX
    document
      .querySelectorAll("input[type=checkbox]:not(input[name=ckbsameamount])")
      .forEach(function (element) {
        if (event.checked) {
          if (element.name !== "chkBoxHeader") {
            element.checked = false;
            element.disabled = true;
            if (element.name === "chkBox") {
              setCheckBoxState(false);
            }
          }
        } else {
          if (event.name === "chkBoxHeader") {
            element.disabled = false;
            element.checked = false;
          }
          if (element.name === "chkBox") {
            setCheckBoxState(true);
          }
        }
      });
  };

  //Función ClearAll del Betslip
  const clearAllBet = () => {
    setCart([]);
    uncheckedAll();
    setCheckBoxState(true);
  };

  const deleteEntryBet = (wagerType, saddleNum, position, raceID) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Delete Entry Bet!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete!",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.value) {
        cart.splice(
          cart.findIndex(
            (item) =>
              item.saddleNum === saddleNum &&
              item.wagerType === wagerType &&
              item.raceID === raceID
          ),
          1
        );
        setCart([...cart]);
        document.querySelector(
          '[idwt="' +
            wagerType +
            '"][saddlenum="' +
            saddleNum +
            '"][position="' +
            position +
            '"]'
        ).checked = false;
      }
    });
  };

  const deleteTicket = (customID) => {
    let elementDelete = [];
    Swal.fire({
      title: "Are you sure?",
      text: "Delete Ticket!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete!",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.value) {
        //delete amount ticket
        setAmounts({
          ...amounts,
          ["amount" + customID]: 0,
        });

        // return the ticket to be deleted
        elementDelete = cart.filter((item) => item.custID === customID);

        elementDelete.forEach((element) => {
          //delete ticket from cart
          cart.splice(
            cart.findIndex((item) => item.custID === element.custID),
            1
          );
          setCart([...cart]);

          // select ckecked checkbox
          let checkedChBx = document.querySelector(
            '[idwt="' +
              element.wagerType +
              '"][saddlenum="' +
              element.saddleNum +
              '"][position="' +
              element.position +
              '"]'
          );
          // unckeck deleted entries
          if (checkedChBx) {
            checkedChBx.checked = false;
          }
        });
      }
    });
  };

  let raceInformation;
  raceInformation = trackInfo?.Races.find(
    (item) => Number(item.RaceID) === Number(raceID)
  );

  return (
    <>
      {loading && <Loading />}

      <div className="col-sm-12">
        <div className="row">
          <div
            className="col-sm-8"
            style={{ paddingLeft: "4px", paddingRight: "2px" }}
          >
            {trackInfo.Races && (
              <RaceInfo
                trackInfo={trackInfo}
                raceInfo={trackInfo.Races.find(
                  (item) => item.RaceID === raceID
                )}
              />
            )}
            {raceInformation.RaceStatus === "O" ? (
              <WagerTypesRace
                raceInfo={trackInfo.Races.find(
                  (item) => item.RaceID === raceID
                )}
                entriesInfo={entriesInfo}
                addToCart={addToCart}
                ticketIndex={ticketIndex}
                setTicketIndex={setTicketIndex}
                disabledAll={disabledAll}
                races={trackInfo.Races}
                checkBoxState={checkBoxState}
                setCheckBoxState={setCheckBoxState}
                getEntriesRace={getEntriesRace}
                entriesPicks={entriesPicks}
                setIndexTab={setIndexTab}
                indexTab={indexTab}
              />
            ) : (
              <div className="tab-content" style={{ padding: "10px 30px" }}>
                {raceInformation.RaceStatus === "C" && (
                  <div style={{ boxShadow: "5px 5px 20px #d9e6f2" }}>
                    <div className="mb-5 mt-1">
                      <Results
                        raceInfo={trackInfo.Races.find(
                          (item) => item.RaceID === raceID
                        )}
                        resultsList={resultsList}
                      />
                    </div>
                  </div>
                )}
                <div className="mt-4">
                  <EntriesTable
                    raceInfo={trackInfo.Races.find(
                      (item) => item.RaceID === raceID
                    )}
                    entriesInfo={entriesInfo}
                    disabledAll={disabledAll}
                    checkBoxState={checkBoxState}
                  />
                </div>
              </div>
            )}
          </div>
          {/* Columna derecha */}
          <div
            className="col-sm-4"
            style={{
              paddingLeft: "3px",
              paddingRight: "3px",
            }}
          >
            <div
              className="containerInformation"
              id=""
              style={{
                minHeight: "calc(90vh - 15px)",
              }}
            >
              <Betslip
                cart={cart}
                setCart={setCart}
                loginPlayerInfo={loginPlayerInfo}
                deleteEntryBet={deleteEntryBet}
                deleteTicket={deleteTicket}
                clearAllBet={clearAllBet}
                uncheckedAll={uncheckedAll}
                setCheckBoxState={setCheckBoxState}
                amounts={amounts}
                setAmounts={setAmounts}
                getStatistics={getStatistics}
                setTicketIndex={setTicketIndex}
                session={session}
                setSessionNoLongerExists={setSessionNoLongerExists}
                publicIP={publicIP}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
  //   } else {
  //     return <></>;
  //   }
};

export default Container;
